import React, {useReducer} from 'react';
import {ContentAdDesktop} from 'app/styles/content';
import {useDispatch} from 'react-redux';
import AlltimeHeader from 'app/components/alltimeStandings/alltimeHeader';
import AlltimeRow from 'app/components/alltimeStandings/alltimeRow';
import {Helmet} from 'react-helmet-async';
import {TITLE_POSTFIX} from 'app/seo/seo.constants';
import {LoadingIndicator, LOADING_MESSAGE, Typography, SIZES} from '@fupa/fupa-uikit';
import {fetchLeagueAlltime} from 'app/routes/league/LeagueAlltimePageActions';
import {AdSlot} from 'app/components/ads/AdSlot';
import {useParams} from 'react-router';
import {useRestoreData, useFetchData, useDataFetchFinished} from 'app/hooks/dataHooks';
import {LeagueAlltimePageReducer} from 'app/routes/league/LeagueAlltimePageReducer';
import styled from 'styled-components';

const Note = styled(Typography)`
  display: inline-flex;
  padding: 0 ${SIZES['16']};
`;

const LeagueAlltimePage = () => {
  const {restoredData} = useRestoreData('LeagueAlltimePage');
  const {leagueSlug} = useParams();
  const dispatchRedux = useDispatch();

  const initialState = restoredData ?? {
    league: {},
    teams: [],
    isFetching: false,
  };

  const [state, dispatch] = useReducer(LeagueAlltimePageReducer, initialState);

  const loadData = () => fetchLeagueAlltime(leagueSlug, dispatchRedux)(dispatch, state);

  const {league, teams, isFetching} = state;
  const loadingDataFinished = useDataFetchFinished(isFetching);
  useFetchData(state, loadData, 'LeagueAlltimePage');

  const districtName = league.district?.name ?? '';
  const title = `Ewige Tabelle - ${league.name} - ${districtName}${TITLE_POSTFIX}`;
  const meta = [
    {name: 'description', content: `Die Ewige Tabelle der Liga ${league.name} - Kreis ${districtName}.`},
    {name: 'robots', content: 'index, nofollow'},
  ];

  const TeamRows = teams.map(team => <AlltimeRow key={team.team.slug} team={team} />);
  let adUnit;
  if (loadingDataFinished) {
    if (teams.length > 0) {
      TeamRows.length > 4 ? TeamRows.splice(5, 0, <AdSlot key='Content_1' adUnit='Content_1' />) : null;
    }
    // Place ad units if content length is not long enough
    // use same key name to get console errors if container is created twice because this would cause too many ad bidder request
    adUnit = !TeamRows.length || TeamRows.length <= 4 ? <AdSlot key='Content_1' adUnit='Content_1' /> : null;
  }

  const content = isFetching ? <LoadingIndicator message={LOADING_MESSAGE.loadingData} /> : TeamRows;
  return (
    <ContentAdDesktop noTabs top='4.5rem'>
      <Helmet title={title} meta={meta} />
      <Note variant={'caption1'}>1) berücksichtigt sind alle Eintragungen in die FuPa-Datenbank</Note>
      <AlltimeHeader />
      {content}
      {adUnit}
    </ContentAdDesktop>
  );
};

export default LeagueAlltimePage;
